import { useSplide } from '~/lib/splide'


document.addEventListener('DOMContentLoaded', () => {

  useSplide('.banner__home', {
    rewind: true,
    autoplay: true,
    interval: 4000,
    pauseOnHover: false,
    arrows: false,
  })
    ?.then((splide) => {
      splide?.mount()
    })
  
})